import styled from "@emotion/styled";
import { Box } from "@mui/material";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import colors from "assets/scss/colors.module.scss";

const iconColor = colors.santasgrey;

export const Loader = styled("img")`
  max-width: 50px;
  width: 100%;
  height: 50px;
  display: block;
  margin: 10px auto;
`;

export const NotificationMessageBox = styled("div")(
  ({ isCursorPointer }) => `
    cursor : ${isCursorPointer ? "pointer" : "unset"};
    margin-right: 7px;
`
);

export const StyledBox = styled(Box, {
  shouldForwardProp: (props) => props !== "isNotificationRead",
})(
  ({ isNotificationRead, theme }) =>
    `
    padding: 10px;
    border-radius: 10px;
    margin: 10px 0;
    background-color: ${
      isNotificationRead
        ? theme.palette.mode === "dark"
          ? colors.darkThemeReadNotification
          : colors.readNotification
        : theme.palette.mode === "dark"
        ? colors.darkThemeUnreadNotification
        : colors.unreadNotification
    };
    .notification-date {
      display:flex;
      justify-content: flex-end;
      font-size: 14px;
    }
  `
);

export const CheckedIcon = styled(CheckCircleOutlinedIcon)`
  color: ${iconColor};
  font-size: 18px;
`;

export const DeleteIcon = styled(DeleteOutlineIcon)`
  color: ${iconColor};
  font-size: 18px;
`;

export const NotificationHeaderWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
